import { css } from 'styled-components';
import fontSizes from '../../../theme/displate/fontSizes';
import { media } from '../../../theme/shared/breakpoints';
import { HeadingSizeType } from './Heading.enum';
const sizes = {
    [HeadingSizeType.TITLE72]: css `
    letter-spacing: -0.014em;
    line-height: 64px;
    font-size: ${fontSizes.sizeLg4};
  `,
    [HeadingSizeType.TITLE60]: css `
    letter-spacing: -0.012em;
    line-height: 56px;
    font-size: ${fontSizes.sizeLg3};
  `,
    [HeadingSizeType.TITLE48]: css `
    letter-spacing: -0.011em;
    line-height: 48px;
    font-size: ${fontSizes.sizeLg2};
  `,
    [HeadingSizeType.TITLE36]: css `
    letter-spacing: -0.009em;
    line-height: 40px;
    font-size: ${fontSizes.sizeLg1};
  `,
    [HeadingSizeType.TITLE28]: css `
    letter-spacing: -0.007em;
    line-height: 32px;
    font-size: ${fontSizes.sizeMd5};
  `,
    [HeadingSizeType.TITLE24]: css `
    letter-spacing: -0.005em;
    line-height: 24px;
    font-size: ${fontSizes.sizeMd4};
  `,
    [HeadingSizeType.TITLE20]: css `
    letter-spacing: 0;
    line-height: 24px;
    font-size: ${fontSizes.sizeMd3};
  `,
    [HeadingSizeType.TITLE18]: css `
    letter-spacing: 0;
    line-height: 24px;
    font-size: ${fontSizes.sizeMd2};
  `,
    [HeadingSizeType.TITLE16]: css `
    letter-spacing: 0;
    line-height: 24px;
    font-size: ${fontSizes.sizeMd1};
  `,
    [HeadingSizeType.TITLE14]: css `
    letter-spacing: 0;
    line-height: 16px;
    font-size: ${fontSizes.sizeSm3};
  `,
    [HeadingSizeType.TITLE12]: css `
    letter-spacing: 0;
    line-height: 16px;
    font-size: ${fontSizes.sizeSm2};
  `,
};
const handleHeadingSizeParams = (headingSize) => {
    switch (headingSize) {
        case HeadingSizeType.TITLE72:
            return css `
        ${sizes[HeadingSizeType.TITLE48]}
        ${media.medium} {
          ${sizes[HeadingSizeType.TITLE60]};
        }
        ${media.large} {
          ${sizes[HeadingSizeType.TITLE72]};
        }
      `;
        case HeadingSizeType.TITLE60:
            return css `
        ${sizes[HeadingSizeType.TITLE48]}
        ${media.medium} {
          ${sizes[HeadingSizeType.TITLE60]};
        }
      `;
        case HeadingSizeType.TITLE48:
            return css `
        ${sizes[HeadingSizeType.TITLE36]}
        ${media.small} {
          ${sizes[HeadingSizeType.TITLE48]}
        }
      `;
        case HeadingSizeType.TITLE36:
            return css `
        ${sizes[HeadingSizeType.TITLE24]}
        ${media.small} {
          ${sizes[HeadingSizeType.TITLE28]}
        }
        ${media.large} {
          ${sizes[HeadingSizeType.TITLE36]}
        }
      `;
        case HeadingSizeType.TITLE28:
            return css `
        ${sizes[HeadingSizeType.TITLE24]}
        ${media.large} {
          ${sizes[HeadingSizeType.TITLE28]}
        }
      `;
        case HeadingSizeType.TITLE24:
            return css `
        ${sizes[HeadingSizeType.TITLE20]}
        ${media.medium} {
          ${sizes[HeadingSizeType.TITLE24]}
        }
      `;
        default:
            return css `
        ${sizes[headingSize]}
      `;
    }
};
export { handleHeadingSizeParams };
//# sourceMappingURL=Heading.helpers.js.map